import Secure from "../kkwebmod/Common/Secure";

(window as any).KKSHA256 = Secure.SHA256;